export enum UserRole {
  USER = 'user',       
  ADMIN = 'admin',    
}

// export const PUBLIC_ROLES: UserRole[] = [
//   UserRole.CUSTOMER,
//   UserRole.RESTAURANT_OWNER,
//   UserRole.COURIER,
// ];